import { Text } from '@/components/ui/Text';
import { DollarSign } from 'lucide-react';

/**
 * Public: Banner shown when a discount code has been successfully applied to
 * the quote. Mirrors the layout of DiscountCodeError but uses positive,
 * cream-toned styling and a dollar-sign icon to confirm the discount.
 *
 * percentage - The percentage reduction applied to the quote (e.g. 10 for 10%).
 */
export function DiscountAppliedNotice({ percentage }: { percentage: number }) {
  return (
    <div className='bg-sh-yellow flex items-center gap-3 rounded-[6px] p-4'>
      <div className='bg-sh-cream flex h-8 w-8 shrink-0 items-center justify-center rounded-full'>
        <DollarSign className='text-sh-dark-gray h-4 w-4' />
      </div>
      <Text variant='body'>
        {[
          'Your ',
          <span key='amount' className='font-bold'>
            {percentage}% discount
          </span>,
          ' has been applied.',
        ]}
      </Text>
    </div>
  );
}
